import { render, staticRenderFns } from "./iot-detail.vue?vue&type=template&id=67122347&scoped=true"
import script from "./iot-detail.vue?vue&type=script&lang=ts"
export * from "./iot-detail.vue?vue&type=script&lang=ts"
import style0 from "./iot-detail.vue?vue&type=style&index=0&id=67122347&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67122347",
  null
  
)

export default component.exports